<div style="min-height: calc(100vh - 320px);">
  <section class="wrapper">
    <saldo-page-header [parentHeaderText]="'Klassifikaatorid'"
                       [headerText]="'Tehingupartnerid'"
                       [addItemText]="'Lisa uus'"
                       [dwnLoaded]="dwnLoaded"
                       [hasAdministratorRole]="hasAdministratorRole()"
                       (onAddNewItem)="goToNewPartnerClassifier(null, null)"
                       (onSaveAsExcel)="saveAsExcel()"
                       (onSaveAsXml)="saveAsXml()"
    ></saldo-page-header>
    <saldo-simple-table [list]="list"
                        [columns]="columns"
                        [templates]="actionTemplate"
                        *ngIf="loaded;else spinner"
                        [showActions]="hasAdministratorRole()"
                        [shouldKeepState]="true"
                        [uniqueIdMapIdentifier]="mapIdentifier"
                        [uniqueKeepStateIdentifier]="shouldKeepStateIdentifier"
    ></saldo-simple-table>
  </section>
  <ng-template #actionTemplate let-items="items">
    <a (click)="goToNewPartnerClassifier(items.code, items.id)">
      <i class="material-icons-outlined mr-1">add</i>
    </a>
    <a (click)="goToEditPage(items.id)" *ngIf="items.upperPartnerCode != null">
      <i class="material-icons-outlined mr-1">edit</i>
    </a>
    <saldo-popover [title]="'Klassifikaatori eemaldamine'"
                   [type]="'delete'"
                   [popoverText]="createDeleteMessage(items.contactPerson)"
                   [deleteDetails]="items.id" deleteBtnClassName="danger"
                   (delete)="deleteItem($event)"
    ></saldo-popover>
  </ng-template>
</div>
<ng-template #spinner>
  <saldo-spinner></saldo-spinner>
</ng-template>
